import { render } from "./UserLink.vue?vue&type=template&id=2de98454&scoped=true"
import script from "./UserLink.vue?vue&type=script&lang=js"
export * from "./UserLink.vue?vue&type=script&lang=js"

import "./UserLink.vue?vue&type=style&index=0&id=2de98454&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de98454"]])

export default __exports__